{
  "CANNED_MGMT": {
    "HEADER": "Brzi odgovori",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Nema stavki koje se poklapaju sa upitom.",
    "LIST": {
      "404": "Ne postoje brzi odgovori u ovom nalogu.",
      "TITLE": "Upravljajte brzim odgovorima",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Sadržaj",
        "INBOXES": "Sandučići",
        "ACTIONS": "Akcije"
      },
      "ALL_INBOXES": "Svi sandučići",
      "FILTER": {
        "ALL_INBOXES": "Svi sandučići",
        "NO_INBOX": "Bez sandučeta",
        "SEARCH_PLACEHOLDER": "Traži sandučiće"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Предмет (само имејл)",
          "PLACEHOLDER": "Опциони предмет за имејл одговоре / нове разговоре"
        },
        "CONTENT": {
          "LABEL": "Poruka",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Прилози"
        },
        "INBOXES": {
          "LABEL": "Sandučići",
          "PLACEHOLDER": "Izaberite sandučiće (opciono, ostavite prazno za sve sandučiće)"
        },
        "SUBMIT": "Pošalji"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Предмет (само имејл)",
          "PLACEHOLDER": "Опциони предмет за имејл одговоре / нове разговоре"
        },
        "CONTENT": {
          "LABEL": "Poruka",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Poruka je obavezna."
        },
        "ATTACHMENTS": {
          "LABEL": "Прилози"
        },
        "INBOXES": {
          "LABEL": "Sandučići",
          "PLACEHOLDER": "Izaberite sandučiće (opciono, ostavite prazno za sve sandučiće)"
        },
        "SUBMIT": "Pošalji"
      },
      "BUTTON_TEXT": "Uredi",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Obriši",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
      },
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Sigurni ste da želite izbrisati ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
